export default __webpack_public_path__ + "static/media/vacationimage.535f7cfc.jpg";